// Module
var code = "<div class=\"axis-names\"></div> <div class=\"{{ editor.options.axis.toLowerCase() }}Axis-field-container axis-field-container\" data-test-id=\"{{ editor.options.axis.toLowerCase() }}-axis-container\"></div> <div class=\"axis-types\"></div> <div class=\"datetime-format\"></div> ";
// Exports
export default code;